import React from 'react';
import './Button.css';

function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  isLoading = false,
  disabled = false,
  className = '',
  icon: Icon,
  ...rest
}) {
  const classes = [
    'btn',
    `btn-${variant}`,
    `btn-${size}`,
    fullWidth ? 'btn-block' : '',
    isLoading ? 'is-loading' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} disabled={disabled || isLoading} {...rest}>
      {isLoading ? (
        <span className="btn-content">
          <span className="spinner"></span>
          <span>{typeof children === 'string' ? children : 'Loading...'}</span>
        </span>
      ) : (
        <span className="btn-content">
          {Icon && <Icon className="btn-icon" size={size === 'sm' ? 16 : 18} />}
          {children && <span>{children}</span>}
        </span>
      )}
    </button>
  );
}

export default Button;
